import React from 'react';
import formattedCurrency from '../../helpers/currencyFormat';
// Component for each product side button
const ExtraSideButton = ({ side, displaySide, buttonText, icon, iconSelected, currentSide, extrasAdded, removeExtras, strings, unitPrice, }) => {
    const checkCurrent = currentSide === side;
    const selectedIcon = (React.createElement("img", { src: iconSelected, alt: `${buttonText} selected icon` }));
    const unselectedIcon = (React.createElement("img", { src: icon, alt: `${buttonText} icon` }));
    return (React.createElement("button", { className: `hg-modal__product-side extra${checkCurrent ? ' active' : ''}${extrasAdded ? ' extras-added' : ''}`, onClick: () => displaySide(side), type: "button" },
        checkCurrent ? selectedIcon : unselectedIcon,
        React.createElement("div", { className: "hg-modal__product-side--text-wrapper" },
            React.createElement("span", { className: "hg-modal__product-side--caption" }, extrasAdded ? strings.extra_added_label : strings.extra_available_label),
            React.createElement("span", { className: "hg-modal__product-side--side-name" }, buttonText),
            unitPrice != 0 ? (React.createElement("span", { className: "hg-modal__product-side--price" },
                "+",
                formattedCurrency(unitPrice, false),
                " ",
                strings.extra_qty_suffix)) : null),
        React.createElement("label", { className: "hg-modal__product-side--checkbox" },
            React.createElement("input", { type: "checkbox", checked: extrasAdded, readOnly: true }),
            React.createElement("span", { className: "checkmark" })),
        React.createElement("div", { className: "hg-modal__product-side--remove-btn", onClick: () => removeExtras(side) },
            React.createElement("span", null, strings.extra_remove_btn),
            React.createElement("span", { className: "cross" }))));
};
export default ExtraSideButton;
